import {
    getSelectedAccountMailboxInfo,
    isAccountSourceListStoreInitialized,
} from 'owa-account-source-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';
import { trace } from 'owa-trace';
import { getStore } from '../store/store';

export default function folderNameToId(folderName: string, mailboxInfo?: MailboxInfo): string {
    if (!folderName) {
        throw new Error('Input parameter to folderNameToId must not be null.');
    }

    // Technical Debt: Because 'mailboxInfo?: MailboxInfo' is optional we will call getSelectedAccountMailboxInfo,
    // which will throw an exception if the account source list store is not initialized, check the initialization
    // state before getting the MailboxInfo. When mailboxInfo is required this check can go away.
    if (!isAccountSourceListStoreInitialized()) {
        trace.info('folderNameToId called before account store is initialized');
        return '';
    }

    // Reflow technical debt, if no mailbox was passed in use the selected mailboxInfo
    const key = mailboxInfo
        ? getIndexerValueForMailboxInfo(mailboxInfo)
        : getIndexerValueForMailboxInfo(getSelectedAccountMailboxInfo());

    let folderId;
    if (key) {
        folderId = getStore()
            .accountScopeUserSettingsMap.get(key)
            ?.defaultFolderNameToIdMap.get(folderName);
    }

    return folderId ?? '';
}
